import { Component } from '@angular/core';
import { BrandingPanel } from '@features/auth/components/branding-panel/branding-panel';
import { LoginForm } from '@features/auth/components/login-form/login-form';
import { BRANDING } from '@features/auth/models/branding.data';
import { LucideUser } from '@lucide/angular';
import { ContentWrapper } from '@ui/components/content-wrapper/content-wrapper';
import { PageLayout } from '@ui/components/page-layout/page-layout';
import { PageSection } from '@ui/components/page-section/page-section';

@Component({
  selector: 'app-login',
  imports: [
    PageLayout,
    PageSection,
    ContentWrapper,
    BrandingPanel,
    LoginForm
  ],
  templateUrl: './login.html',
})
export class Login {
  branding = BRANDING;
  protected readonly userIcon = LucideUser;
}
